export const PROCEED_EVENT_NAME = 'proceed'
export const LOAD_EVENT_NAME = 'load'
export const PAYMENT_REDIRECT_HASH: Record<string, string> = {
  CC: import.meta.env.VUE_APP_REDIRECT_PAYMENT_CC,
  DC: import.meta.env.VUE_APP_REDIRECT_PAYMENT_DC,
}
